// extracted by mini-css-extract-plugin
export default {"wrapper":"AppBar_wrapper__Ut-g+"};